import axios from 'axios';
import apiUrl from '../../api.config'

const VOICE_API_URL = `${apiUrl}voice`;

class VoiceService {
    uploadCheckVoice(formData) {
        return axios.post(VOICE_API_URL + '/uploadCheckVoice', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        });
    }

    // 新增音頻檢查方法
    audioCheck(audioBlob) {
        const formData = new FormData();
        formData.append('audio_file', audioBlob, 'check.mp3');
        
        return axios.post(VOICE_API_URL + '/audioCheck', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        });
    }
}

export default new VoiceService();